export default __webpack_public_path__ + "static/kv-banner-lt-cht-e1d13f7c5ab760125c35abedc1a78e3f.png";